(function() {
    const REF_KEY = 'shopify_referrer_id';
    const EXPIRY_DAYS = 3;

    // --- 1. 经典的 Cookie 读写函数 ---
    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
    };

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    // --- 2. 初始化：解析 URL 并更新 Cookie ---
    const urlRef = new URLSearchParams(window.location.search).get('ref');
    if (urlRef) {
        setCookie(REF_KEY, urlRef, EXPIRY_DAYS); // 每次点击推荐链接，都会重置 30 天有效期
    }

    const activeRef = getCookie(REF_KEY);
    if (!activeRef) return; // 如果没有推荐 ID，后续拦截逻辑均不执行

    // --- 3. 加购表单注入 (针对 Liquid 自定义按钮和传统表单) ---
    const injectForm = () => {
        document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
            let input = form.querySelector('input[name="attributes[referral_id]"]');
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'attributes[referral_id]';
                form.appendChild(input);
            }
            input.value = activeRef;
            console.log('⚡ 加购 form 注入成功');
        });
    };
    injectForm();
    // 监听动态生成的商品（如弹窗加购）
    new MutationObserver(injectForm).observe(document.body, { childList: true, subtree: true });

    // --- 4. GraphQL 拦截注入 (针对 Buy It Now 动态按钮) ---
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
        let [resource, config] = args;
        if (typeof resource === 'string' && resource.includes('cartCreate') && config?.body) {
            try {
                let body = JSON.parse(config.body);
                if (body.variables?.input) {
                    body.variables.input.attributes = [{ "key": "referral_id", "value": activeRef }];
                    config.body = JSON.stringify(body);
                    console.log('⚡ GraphQL 注入成功');
                }
            } catch (e) {}
        }
        return originalFetch(resource, config);
    };

    // --- 5. 结账按钮的 Ajax 注入 (保底方案：解决复购及 Session 丢失) ---
    document.addEventListener('click', (e) => {
        // 匹配购物车页面或侧边栏的结账按钮
        const checkoutBtn = e.target.closest('button[name="checkout"], [href="/checkout"], .checkout-button');
        if (checkoutBtn) {
            // 使用 navigator.sendBeacon 确保在页面跳转前的最后一刻发送 Ajax
            // 这会自动把 referral_id 写入 Shopify 的 Cart Session
            const payload = JSON.stringify({ attributes: { 'referral_id': activeRef } });
            const blob = new Blob([payload], { type: 'application/json' });
            navigator.sendBeacon('/cart/update.js', blob);
            console.log('🚀 结账前 Ajax 保底注入');
        }
    }, true);

})();